import { f as formatMoney } from "./currency-DRNmrEpZ.js";
import { m as moveToSlide } from "./product-media-slider-DEHL8nRa.js";
import "./splide.esm-Cg9MkWOe.js";
class Product extends HTMLElement {
  constructor() {
    super();
    this._selectedVariant = null;
    this._product = null;
  }
  static get observedAttributes() {
    return ["selected-variant-id"];
  }
  connectedCallback() {
    this.loadProductData();
    this.setupEventListeners();
    this.stickyAddToCart();
    this.saveProductHandleInSessionStorage();
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "selected-variant-id" && oldValue !== newValue) {
      this.updateSelectedVariant(newValue);
      this.updateProductDetails();
    }
  }
  get selectedVariantId() {
    return this.getAttribute("selected-variant-id");
  }
  set selectedVariantId(value) {
    if (value !== null) {
      this.setAttribute("selected-variant-id", value);
    } else {
      this.removeAttribute("selected-variant-id");
    }
  }
  setSelectedVariantId(variantId) {
    this.selectedVariantId = variantId;
  }
  get selectedVariant() {
    return this._selectedVariant;
  }
  loadProductData() {
    const productJson = this.getAttribute("product");
    if (productJson) {
      try {
        this._product = JSON.parse(productJson);
      } catch (e) {
        console.error("Error parsing product data:", e);
      }
    } else {
      console.error("Product attribute is missing or empty");
    }
  }
  updateSelectedVariant(variantId) {
    if (!this._product || !this._product.variants) {
      console.error("No product or variants available");
      return;
    }
    const variant = this._product.variants.find(
      (v) => String(v.id) === variantId
    );
    if (variant) {
      this._selectedVariant = variant;
    } else {
      console.error("Variant with id", variantId, "not found");
    }
  }
  updateProductDetails() {
    if (!this._selectedVariant) {
      console.error("No selected variant available");
      return;
    }
    const { price, compare_at_price, featured_media, available } = this._selectedVariant;
    const variantImageIndex = featured_media.position - 1;
    const productDetails = {
      productMediaSlider: this.querySelector(
        "uwp-product-media-slider"
      ),
      price: this.querySelector("[data-price]"),
      comparePrice: this.querySelector("[data-compare-at-price]"),
      addToCartButton: this.querySelector("[data-add-to-cart]")
    };
    if (productDetails.price) {
      productDetails.price.textContent = formatMoney(price);
    }
    if (productDetails.comparePrice) {
      productDetails.comparePrice.textContent = compare_at_price ? formatMoney(compare_at_price) : "";
    }
    if (productDetails.productMediaSlider) {
      moveToSlide(productDetails.productMediaSlider, variantImageIndex);
    }
    if (productDetails.addToCartButton) {
      productDetails.addToCartButton.toggleAttribute("disabled", !available);
    }
  }
  setupEventListeners() {
    const atcButton = document.querySelector("#atcButton");
    const variantButtons = this.querySelectorAll("[data-qty-button]");
    const inputs = this.querySelectorAll("[data-qty-input]");
    if (atcButton) {
      atcButton.addEventListener("click", () => {
        inputs.forEach((input) => {
          input.value = "0";
          input.dispatchEvent(new Event("change"));
        });
      });
    }
    variantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.updateTotalPrice(inputs);
        const noQuantityParent = button.closest(
          ".product-swatches--no-quantity"
        );
        if (noQuantityParent) {
          noQuantityParent.classList.remove("product-swatches--no-quantity");
        }
      });
    });
  }
  updateTotalPrice(inputs) {
    let totalPrice = 0;
    inputs.forEach((input) => {
      const quantity = parseInt(input.value, 10);
      const price = parseFloat(input.dataset.price || "0");
      if (!isNaN(quantity) && !isNaN(price) && quantity > 0) {
        totalPrice += quantity * price;
      }
    });
    this.displayTotalPrice(totalPrice);
  }
  displayTotalPrice(totalPrice) {
    const atcButtonTotal = this.querySelector("[data-product-total]");
    if (atcButtonTotal && totalPrice > 0) {
      atcButtonTotal.innerHTML = `<span class="atc-breaker">|</span>${formatMoney(totalPrice)}`;
    } else if (atcButtonTotal) {
      atcButtonTotal.innerHTML = "";
    }
  }
  stickyAddToCart() {
    const atcButtonWrapper = this.querySelector("[js-atc-wrapper]");
    const atcVisibleDiv = this.querySelector("[js-atc-visible]");
    if (atcButtonWrapper && atcVisibleDiv) {
      const clonedButton = atcButtonWrapper.cloneNode(true);
      clonedButton.classList.add("placeholder", "hide");
      atcButtonWrapper.after(clonedButton);
      window.onscroll = () => {
        if (window.innerWidth < 768) {
          const sticky = atcVisibleDiv.offsetTop;
          const chatButton = document.getElementById("CookiebotWidget");
          if (chatButton) {
            chatButton.style.transition = "bottom .3s ease";
          }
          if (window.scrollY > sticky) {
            atcButtonWrapper.classList.add("sticky");
            clonedButton.classList.remove("hide");
            chatButton == null ? void 0 : chatButton.style.setProperty("bottom", "70px");
          } else {
            atcButtonWrapper.classList.remove("sticky");
            clonedButton.classList.add("hide");
            chatButton == null ? void 0 : chatButton.style.setProperty("bottom", "10px");
          }
        }
      };
    }
  }
  saveProductHandleInSessionStorage() {
    var _a;
    const previousUrl = document.referrer;
    if (!previousUrl.includes("/collections/")) {
      localStorage.removeItem("productHandle");
      return;
    }
    const productHandle = (_a = this._product) == null ? void 0 : _a.handle;
    if (productHandle) {
      sessionStorage.setItem("productHandle", productHandle);
    }
  }
}
customElements.define("uwp-product", Product);
